import { render, staticRenderFns } from "./TopSellingItemsWithInventoryReport.vue?vue&type=template&id=07dbdacc&"
import script from "./TopSellingItemsWithInventoryReport.vue?vue&type=script&lang=js&"
export * from "./TopSellingItemsWithInventoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports